import React from 'react';
import PropTypes from 'prop-types';
import LogInForm from '../LogInForm/LogInForm';

const getRoomSigninFields = room => {
    if (!(room && room.roomConfigurations)) return {};
    return room.roomConfigurations.find(config => config.name === 'student_signin_fields');
};

const SignIn = ({ handleNav, meeting, room }) => {
    return (
        <div className="grid-y medium-grid-frame">
            <div className="grid-x medium-grid-frame">
                <section className="cell">
                    <LogInForm afterSubmitCallback={handleNav} meeting={meeting} roomSigninFields={getRoomSigninFields(room)} />
                </section>
            </div>
        </div>
    );
};

export default SignIn;

SignIn.propTypes = {
    handleNav: PropTypes.func,
    meeting: PropTypes.any,
    room: PropTypes.any,
};



// WEBPACK FOOTER //
// ./src/components/login-flow-components/SignIn/SignIn.jsx